import React, { useState } from "react";
import PropTypes from "prop-types";
import { Popover } from "@material-ui/core";
import clsx from "clsx";
import { Button } from "../../atomicComponents";
import styles from "./CapacityForm.module.css";

const CapacityForm = ({
  selectedRecord,
  recordLabel,
  formTitle,
  closeFormPopup,
  updateCapacity,
}) => {
  const [newCapacity, setNewCapacity] = useState(
    selectedRecord.maxCapacity
  );

  const handleSubmit = () => {
    updateCapacity(Number(newCapacity));
  };

  return (
    <Popover
      open={true}
      anchorOrigin={{
        vertical: "center",
        horizontal: "center",
      }}
      transformOrigin={{
        vertical: "center",
        horizontal: "center",
      }}
      className={styles.popoverBck}
    >
      <div className={styles.formBox}>
        <div className={styles.formTitleNew}>
          <span className={styles.formTitle}>
            {formTitle}
          </span>
          <div className={styles.formLineDiv} />
        </div>

        <div className={styles.box}>
          <span className={styles.titleSpan}>
            {recordLabel}
          </span>

          <span className={styles.valueText}>
            {selectedRecord.name}
          </span>
        </div>

        <div className={styles.box}>
          <span className={styles.titleSpan}>
            Current Capacity
          </span>

          <span className={styles.valueText}>
            {selectedRecord.maxCapacity}
          </span>
        </div>

        <div className={styles.box}>
          <span className={styles.titleSpan}>
            New Capacity
          </span>

          <input
            type="number"
            value={newCapacity}
            onChange={(e) =>
              setNewCapacity(e.target.value)
            }
            className={styles.input}
          />
        </div>

        <div style={{ float: "right" }}>
          <Button
            variant="primary"
            className={clsx(
              styles.button,
              styles.confirmButton
            )}
            onClick={handleSubmit}
          >
            UPDATE
          </Button>

          <Button
            className={clsx(
              styles.button,
              styles.cancelButton
            )}
            onClick={closeFormPopup}
          >
            CANCEL
          </Button>
        </div>
      </div>
    </Popover>
  );
};

CapacityForm.propTypes = {
  selectedRecord: PropTypes.object.isRequired,
  recordLabel: PropTypes.string.isRequired,
  formTitle: PropTypes.string.isRequired,
  closeFormPopup: PropTypes.func.isRequired,
  updateCapacity: PropTypes.func.isRequired,
};

export default CapacityForm;